var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { Grid, Link, Typography } from '@mui/material';
import { GRID_AGGREGATION_ROOT_FOOTER_ROW_ID, GRID_CHECKBOX_SELECTION_FIELD, GRID_ROW_GROUPING_SINGLE_GROUPING_FIELD, gridClasses } from '@mui/x-data-grid-premium';
import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { EditableDataGrid } from '../../../builderPackage/components/editableDataGrid/editableDataGrid';
import { RowModeIds } from '../../../builderPackage/components/editableDataGrid/editableDataGrid.entity';
import { MuiStack } from '../../../components';
import { LOCAL_STORAGE_KEYS } from '../../../constants';
import { showSurface } from '../../../redux/awaitedSurfacesSlice';
import { setReducerState } from '../../../redux/crudSlice';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import { getLocalStorageItem } from '../../../utils/storageHelper';
import { convertNumberToDecimal } from '../../../utils/utils';
import { REG } from '../../../utils/validationHelper';
import TaxDetailsPopup from '../../jobCard/partGridPopups/taxDetailsPopup';
import { getPartList, getPriceDetailsWithTax, getTechnicianList, validateDeletePartLabour, validateQuantityAndGetTax } from '../services/apiCalls';
import { JobCardKeys } from '../services/entity';
import { partLabourSearchSelectFilterOperators, searchSelectSortComparator } from '../utils/utils';
var JobcardPartGrid = function (props) {
    var _a;
    var id = useParams().id;
    var onChange = props.onChange, value = props.value, error = props.error, _b = props.name, name = _b === void 0 ? 'partDetails' : _b, disabled = props.disabled;
    var currValue = useMemo(function () {
        var _value$name;
        return (_value$name = value[name]) === null || _value$name === void 0 ? void 0 : _value$name.filter(function (item) { return !(item !== null && item !== void 0 && item.IsDeleted); });
    }, [value[name]]);
    var dispatch = useAppDispatch();
    // const [modalProps, setModalProps] = useState<ResponseObject>(); // only UAT v2.5
    var crud = useAppSelector(function (state) { return state.crud; });
    var documentDetailsGetById = crud.documentDetailsGetById, installbaseDetailsById = crud.installbaseDetailsById;
    // const isMobile = useMediaQuery((theme: any) => theme.breakpoints.down("sm"));
    var selectedBranch = getLocalStorageItem(LOCAL_STORAGE_KEYS.SELECTED_BRANCH);
    // const openApprovalModal = async () => {
    //     dispatch(showSurface({
    //         type: 'Dialog',
    //         Component: ApprovalDetailsPopup,
    //         containerProps: { fullWidth: true, maxWidth: 'sm' }
    //     }));
    // }
    // const openApprovalModalForDrawer = async () => {
    //     dispatch(showSurface({
    //         type: 'Drawer',
    //         Component: ApprovalDetailsPopup,
    //         containerProps: { anchor: 'bottom'}
    //     }));
    // }
    // const handleCheckListDetailsPopup = async () => {
    //     const result = await dispatch(showSurface({
    //         type: 'Dialog',
    //         Component: ChecklistDetailsPopup,
    //         containerProps: { fullWidth: true }
    //     }));
    // }
    // const openTaxdetails = async () => {
    //     dispatch(showSurface({
    //         type: 'Dialog',
    //         Component: TaxDetailsPopup,
    //         containerProps: { fullWidth: true, maxWidth: 'xs' }
    //     }));
    // }
    // const openTaxdetailsForDrawer = async () => {
    //     dispatch(showSurface({
    //         type: 'Drawer',
    //         Component: TaxDetailsPopup,
    //         containerProps: { anchor: 'bottom'}
    //     }));
    // }
    // only UAT v2.5
    // const saveRatioBillingDetails = async (ratioData: any, currentRow: any) => {
    //     let ratioDataBody = ratioData.map((item: any, index: number) => {
    //         return {
    //             ServiceTypeBillingRatioSettingId: item.ServiceTypeBillingRatioSettingId,
    //             "HeaderServiceTypeId": documentDetailsGetById?.data?.RepairTypeId,
    //             "LineServiceTypeId": currentRow.ServiceTypeId,
    //             "EntityId": currentRow.EntityId,
    //             "ChildId": currentRow.ChildId,
    //             "Percentage": item.PercentageValue,
    //             "IsChanged": false,
    //             "ServiceTypeBillingRatioSettingSchemaId": item.SchemaId
    //         }
    //     })
    //     const requestBody: any = {
    //         JobcardId: id,
    //         JobCardDetailBillingRatios: ratioDataBody
    //     }
    //     const Response = await dispatch(getListAPI({ key: '', url: upsertRatioBillingDetailsUrl, request: requestBody }));
    //     if (Response?.payload?.value?.success) {
    //         dispatch(
    //             showNotification({
    //                 isOpen: true,
    //                 message: "saved successfully.",
    //                 type: "success"
    //             })
    //         );
    //     }
    // }
    var partsColumns = [{
            type: 'searchSelect',
            field: 'ChildName',
            headerName: 'Part name & code',
            minWidth: 300,
            headerAlign: 'left',
            getListData: getPartList,
            apiKey: 'partList',
            editable: false,
            aggregable: false,
            getOptionLabel: function (option) { return option !== null && option !== void 0 && option.DisplayName ? "".concat(option.DisplayName, " | ").concat(option.SKUCode) : ''; },
            valueGetter: function (value, row) {
                var _ref, _row$ChildCode;
                return "".concat(row === null || row === void 0 ? void 0 : row.ChildName, "  #").concat((_ref = (_row$ChildCode = row === null || row === void 0 ? void 0 : row.ChildCode) !== null && _row$ChildCode !== void 0 ? _row$ChildCode : row === null || row === void 0 ? void 0 : row.SkuCode) !== null && _ref !== void 0 ? _ref : '');
            },
            // getOptionKey: (option: any) => option?.id,
            // valueSetter: (value: any, row) => ({
            //     ...row,
            //     ChildName: value?.Name,
            //     ChildId: value?.id,
            //     ChildCode: value?.SKUCode,
            //     UnitOfMeasurementId: value?.UnitOfMeasurementId,
            //     UnitOfMeasurementName: value?.UnitOfMeasurementName,
            //     Quantity: value?.Quantity
            // }),
            // valueGetter(val, row) {
            //     return {
            //         DisplayName: row?.ChildName ?? '',
            //         ChildId: row?.ChildId ?? null,
            //         SkuCode: row?.ChildCode || row?.Code ||'',
            //         ChildCode : row?.SKUCode || row?.Code ||''
            //     }
            // },
            renderCell: function (params) {
                if ((params === null || params === void 0 ? void 0 : params.id) === RowModeIds.Aggregation) {
                    return 'Total';
                }
                else {
                    var _params$row$ChildName, _params$row, _params$row2, _params$row3, _params$row4, _params$row5;
                    return /*#__PURE__*/ React.createElement(MuiStack, {
                        direction: 'column'
                    }, /*#__PURE__*/ React.createElement(Typography, {
                        variant: "caption"
                    }, (_params$row$ChildName = params === null || params === void 0 || (_params$row = params.row) === null || _params$row === void 0 ? void 0 : _params$row.ChildName) !== null && _params$row$ChildName !== void 0 ? _params$row$ChildName : ""), /*#__PURE__*/ React.createElement(MuiStack, {
                        direction: 'row',
                        alignItems: 'center',
                        justifyContent: 'space-between'
                    }, /*#__PURE__*/ React.createElement(Typography, {
                        variant: "caption",
                        color: 'secondary'
                    }, params !== null && params !== void 0 && (_params$row2 = params.row) !== null && _params$row2 !== void 0 && _params$row2.ChildCode ? "#".concat(params === null || params === void 0 || (_params$row3 = params.row) === null || _params$row3 === void 0 ? void 0 : _params$row3.ChildCode) : params !== null && params !== void 0 && (_params$row4 = params.row) !== null && _params$row4 !== void 0 && _params$row4.SKUCode ? "#".concat(params === null || params === void 0 || (_params$row5 = params.row) === null || _params$row5 === void 0 ? void 0 : _params$row5.SKUCode) : "")));
                }
            }
        }, {
            field: 'HSNSACCode',
            headerName: 'HSN Code',
            width: 150,
            headerAlign: 'left',
            aggregable: false
        }, {
            field: 'UnitOfMeasurementName',
            headerName: 'UOM',
            width: 100,
            headerAlign: 'left',
            editable: false,
            aggregable: false
            // only UAT v2.5
            // type: 'searchSelect',
            // disableColumnMenu: true,
            // getListData: UnitOfMeasurementList,
            // apiKey: 'UnitOfMeasurementList',
            // getOptionLabel: (option: any) => option?.Name ?? '',
            // valueFormatter: (value: any) => value?.Name ?? '',
            // valueSetter: (value: any, row) => ({
            //     ...row,
            //     UnitOfMeasurementName: value?.Name ?? null,
            //     UnitOfMeasurementId: value?.id ?? null
            // }),
            // valueGetter: (val, row) => {
            //     if (!val) return val
            //     return {
            //         Name: row?.UnitOfMeasurementName ?? null,
            //         id: row?.UnitOfMeasurementId ?? null
            //     }
            // }
        }, {
            field: 'ServiceTypeName',
            headerName: 'Service type',
            minWidth: 250,
            headerAlign: 'left',
            editable: false,
            aggregable: false
            // only UAT v2.5
            // type: 'searchSelect',
            // disableColumnMenu: true,
            // getListData: getServiceTypeList,
            // apiKey: 'serviceTypeList',
            // getOptionLabel: (option: any) => option?.DisplayName ?? '',
            // valueFormatter: (value: any) => value?.DisplayName ?? '',
            // getOptionKey: (option: any) => option?.id,
            // valueSetter: (value: any, row) => ({
            //     ...row,
            //     ServiceTypeName: value?.DisplayName ?? null,
            //     ServiceTypeId: value?.ServiceTypeId ?? null
            // }),
            // valueGetter: (val, row) => {
            //     if (!val) return val
            //     return {
            //         DisplayName: row?.ServiceTypeName ?? '',
            //         id: row?.ServiceTypeId ?? null
            //     }
            // }
        }, {
            type: 'searchSelect',
            field: 'TechnicianName',
            headerName: 'Technician',
            minWidth: 300,
            headerAlign: 'left',
            getListData: getTechnicianList,
            apiKey: 'technicianList',
            apiRequest: {
                WorkingOrganizationId: selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.OrganizationId
            },
            editable: true,
            aggregable: false,
            // sortable: false,
            getOptionLabel: function (option) { return option !== null && option !== void 0 && option.FirstName || option !== null && option !== void 0 && option.LastName ? (option === null || option === void 0 ? void 0 : option.FirstName) + " " + (option === null || option === void 0 ? void 0 : option.LastName) : ''; },
            valueFormatter: function (value) {
                var _value$FirstName, _value$LastName;
                if (typeof value === 'string') {
                    return value;
                }
                return ((_value$FirstName = value === null || value === void 0 ? void 0 : value.FirstName) !== null && _value$FirstName !== void 0 ? _value$FirstName : '') + ' ' + ((_value$LastName = value === null || value === void 0 ? void 0 : value.LastName) !== null && _value$LastName !== void 0 ? _value$LastName : '');
            },
            valueSetter: function (value, row) {
                var _value$id;
                if (!value) {
                    return _objectSpread(_objectSpread({}, row), {}, {
                        TechnicianName: null,
                        TechnicianId: null,
                        TechnicianFamilyName: null
                    });
                }
                return _objectSpread(_objectSpread({}, row), {}, {
                    TechnicianName: value === null || value === void 0 ? void 0 : value.FirstName,
                    TechnicianFamilyName: value === null || value === void 0 ? void 0 : value.LastName,
                    TechnicianId: (_value$id = value === null || value === void 0 ? void 0 : value.id) !== null && _value$id !== void 0 ? _value$id : null
                });
            },
            valueGetter: function (val, row) {
                var _row$TechnicianName, _row$TechnicianFamily;
                if (row !== null && row !== void 0 && row.TechnicianName || row !== null && row !== void 0 && row.TechnicianId)
                    return {
                        FirstName: (_row$TechnicianName = row === null || row === void 0 ? void 0 : row.TechnicianName) !== null && _row$TechnicianName !== void 0 ? _row$TechnicianName : '',
                        LastName: (_row$TechnicianFamily = row === null || row === void 0 ? void 0 : row.TechnicianFamilyName) !== null && _row$TechnicianFamily !== void 0 ? _row$TechnicianFamily : '',
                        id: row === null || row === void 0 ? void 0 : row.TechnicianId
                    };
                return null;
            },
            filterOperators: partLabourSearchSelectFilterOperators,
            sortComparator: searchSelectSortComparator
        }, {
            type: 'number',
            field: 'Quantity',
            headerName: 'Requested qty ',
            width: 150,
            headerAlign: 'left',
            filterable: false,
            editable: true,
            valueFormatter: function (value) {
                return convertNumberToDecimal(value);
            }
        }, {
            type: 'number',
            field: 'IssuedQuantity',
            headerName: 'Issued qty ',
            width: 120,
            headerAlign: 'left',
            filterable: false,
            valueFormatter: function (value) {
                return convertNumberToDecimal(value);
            }
        }, {
            type: 'number',
            field: 'PendingQuantity',
            headerName: 'Pending qty ',
            width: 120,
            headerAlign: 'left',
            filterable: false,
            valueFormatter: function (value) {
                return convertNumberToDecimal(value);
            }
        },
        // {
        //     type: 'number',
        //     field: 'AvailableQuantity',
        //     headerName: 'Available qty ',
        //     minWidth: 150,
        //     disableColumnMenu: true,
        //     align: 'right',
        //     renderCell: (params) => {
        //         if (params.id === GRID_AGGREGATION_ROOT_FOOTER_ROW_ID) {
        //             return params.formattedValue
        //         } else {
        //             return <Link
        //                 component="button"
        //                 fontWeight='medium'
        //                 fontSize='sm'
        //                 onClick={async () => {
        //                     const res = await dispatch(showSurface({
        //                         type: 'Dialog',
        //                         Component: AvailableStockPopUp,
        //                         componentProps: { data: params?.row },
        //                         containerProps: { fullWidth: true, maxWidth: 'xs' }
        //                     }))
        //                 }}
        //             >
        //                 {params?.row?.AvailableQuantity}
        //             </Link>
        //         }
        //     }
        // },
        // {
        //     type: 'number',
        //     field: 'NotIssuedQuantity',
        //     headerName: 'Not issued qty',
        //     width: 150,
        //     headerAlign: 'left',
        //     disableColumnMenu: true,
        // },
        {
            type: 'number',
            field: 'CancelQuantity',
            headerName: 'Cancelled qty',
            width: 150,
            headerAlign: 'left',
            filterable: false,
            valueFormatter: function (value) {
                return convertNumberToDecimal(value);
            }
        }, {
            type: 'number',
            field: 'ReturnedQuantity',
            headerName: 'Returned qty',
            width: 150,
            headerAlign: 'left',
            filterable: false,
            valueFormatter: function (value) {
                return convertNumberToDecimal(value);
            }
        }, {
            type: 'number',
            field: 'Rate',
            headerName: 'Rate (₹)',
            width: 100,
            headerAlign: 'left',
            editable: true,
            filterable: false,
            renderCell: function (_ref2) {
                var _row$SavedPriceWithTa;
                var row = _ref2.row, id = _ref2.id;
                if (id === GRID_AGGREGATION_ROOT_FOOTER_ROW_ID) {
                    return undefined;
                }
                return convertNumberToDecimal(row === null || row === void 0 || (_row$SavedPriceWithTa = row.SavedPriceWithTax) === null || _row$SavedPriceWithTa === void 0 ? void 0 : _row$SavedPriceWithTa.Rate);
            }
        },
        // only UAT v2.5
        // {
        //     field: 'TradeDiscountPercentage',
        //     headerName: 'Trade discount (%)',
        //     width: 180,
        //     headerAlign: 'left',
        //     disableColumnMenu: true,
        // },
        // {
        //     type: 'number',
        //     field: 'TradeDiscountAmount',
        //     headerName: 'Trade discount (₹)',
        //     width: 180,
        //     headerAlign: 'left',
        //     disableColumnMenu: true,
        //     valueFormatter: (value) => {
        //         return convertNumberToDecimal(value)
        //     }
        // },
        {
            field: 'SavedPriceWithTax',
            headerName: 'MRP (₹)',
            width: 130,
            headerAlign: 'left',
            apiKey: "MRPList",
            editable: false,
            filterable: false,
            valueFormatter: function (val, row) {
                if (!row.id) {
                    return "";
                }
                var updatedMRP = val || row || 0;
                if (updatedMRP.EffectiveFromDate || updatedMRP.EffectiveToDate) {
                    return "".concat(convertNumberToDecimal(updatedMRP === null || updatedMRP === void 0 ? void 0 : updatedMRP.MRP), "  ").concat(updatedMRP.EffectiveFromDate ? "From: ".concat(updatedMRP.EffectiveFromDate, ")") : "").concat(updatedMRP.EffectiveToDate ? " To: ".concat(updatedMRP.EffectiveToDate) : "");
                }
                else {
                    return "".concat(convertNumberToDecimal(updatedMRP === null || updatedMRP === void 0 ? void 0 : updatedMRP.MRP));
                }
            }
            // only UAT v2.5
            // type: 'searchSelect',
            // getListData: async (params) => {
            //     dispatch((setReducerState({ key: 'MRPList', value: { data: params?.state?.PriceWithTaxList || [], success: true } })))
            //     return { success: true }
            // },
            // getOptionLabel: (option: any) => {
            //     if (option.EffectiveFromDate || option.EffectiveToDate) {
            //         return `${option.MRP}  ${option.EffectiveFromDate ? `From: ${option.EffectiveFromDate})` : ""}${option.EffectiveToDate ? ` To: ${option.EffectiveToDate}` : ""}`
            //     } else {
            //         return `${option.MRP}`
            //     }
            // },
            // isOptionEqualToValue(option, value) {
            //     return option?.MRP === value?.MRP
            // },
        }, {
            type: 'number',
            field: 'TaxableAmount',
            headerName: 'Taxable amount (₹)',
            width: 180,
            headerAlign: 'left',
            filterable: false,
            valueFormatter: function (value) {
                return convertNumberToDecimal(value);
            }
        }, {
            type: 'number',
            field: 'TotalTaxes',
            headerName: 'Total taxes',
            width: 130,
            headerAlign: 'left',
            filterable: false,
            valueGetter: function (value, row) {
                var _row$SavedPriceWithTa2;
                var totalTaxes = row === null || row === void 0 || (_row$SavedPriceWithTa2 = row.SavedPriceWithTax) === null || _row$SavedPriceWithTa2 === void 0 || (_row$SavedPriceWithTa2 = _row$SavedPriceWithTa2.Taxes) === null || _row$SavedPriceWithTa2 === void 0 ? void 0 : _row$SavedPriceWithTa2.reduce(function (sum, component) {
                    return sum + component.TaxComponentAmount;
                }, 0);
                return totalTaxes;
            },
            renderCell: function (_ref3) {
                var row = _ref3.row, id = _ref3.id, value = _ref3.value, formattedValue = _ref3.formattedValue, api = _ref3.api;
                if (id === RowModeIds.Aggregation) {
                    return convertNumberToDecimal(value || 0);
                }
                return /*#__PURE__*/ React.createElement(Link, {
                    component: "button",
                    variant: "body1",
                    underline: "none",
                    onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            dispatch(showSurface({
                                type: 'Dialog',
                                Component: TaxDetailsPopup,
                                containerProps: {
                                    fullWidth: true,
                                    maxWidth: 'xs'
                                },
                                componentProps: {
                                    data: row
                                }
                            }));
                            return [2 /*return*/];
                        });
                    }); }
                }, convertNumberToDecimal(Number(value || 0)));
            }
        },
        // only UAT v2.5
        // {
        //     type: 'searchSelect',
        //     field: 'DefectName',
        //     headerName: 'Defect',
        //     editable: true,
        //     minWidth: 350,
        //     apiKey: JobCardKeys.DefectList,
        //     getListData: getDefectList,
        //     getOptionLabel: (option: any) => option?.ComplaintName ?? '',
        //     valueFormatter: (value: any) => value?.ComplaintName ?? '',
        //     // getOptionKey: (option: any) => option?.DefectId,
        //     apiRequest: {
        //         Name: "Part Defect Code",
        //     },
        //     valueSetter: (value: any, row) => ({
        //         ...row,
        //         DefectName: value?.ComplaintName ?? null,
        //         DefectId: value?.id ?? null
        //     }),
        //     valueGetter: (val, row) => {
        //         if (!val) return val
        //         return {
        //             ComplaintName: row?.DefectName ?? null,
        //             DefectId: row?.DefectId ?? null
        //         }
        //     }
        // },
        // {
        //     field: 'check',
        //     headerName: 'Checksheet',
        //     width: 150,
        //     headerAlign: 'left',
        //     disableColumnMenu: true,
        //     renderCell: (params) => {
        //         if (params?.id === RowModeIds.Aggregation) {
        //             return '';
        //         } else {
        //             return <Link
        //                 underline="none"
        //                 component="button"
        //                 fontWeight='medium'
        //                 fontSize='sm'
        //                 onClick={async () => {
        //                     const result = await dispatch(showSurface({
        //                         type: 'Dialog',
        //                         Component: ChecklistDetailsPopup,
        //                         containerProps: { fullWidth: true, maxWidth: 'md' },
        //                     }));
        //                 }}
        //             >
        //                 View
        //             </Link>
        //         }
        //     }
        // },
        // {
        //     field: 'IssueStatus',
        //     headerName: 'Issue status',
        //     width: 150,
        //     headerAlign: 'left',
        //     disableColumnMenu: true,
        //     renderCell: (params) => {
        //         return params?.row?.IssueStatus
        //             ? <Chip
        //                 label='Active'
        //                 size="small"
        //                 variant="filled"
        //                 color="info"
        //                 sx={{ borderRadius: 2, px: 1, fontWeight: 'bold', fontSize: '12px' }}
        //             /> : ''
        //     }
        // },
        // {
        //     field: 'Approval',
        //     headerName: 'Approval',
        //     width: 120,
        //     headerAlign: 'left',
        //     disableColumnMenu: true,
        //     renderCell: (params) => {
        //         if (params?.id === RowModeIds.Aggregation) {
        //             return '';
        //         } else {
        //             return <Link
        //                 component="button"
        //                 fontSize='sm'
        //                 fontWeight='medium'
        //                 onClick={async (e) => {
        //                     const res = await dispatch(showSurface({
        //                         type: 'Dialog',
        //                         Component: ApprovalDetailsPopup,
        //                         containerProps: { fullWidth: true, maxWidth: 'sm' },
        //                         componentProps: { data: params?.row }
        //                     }));
        //                     if (res?.payload) {
        //                         const updatedRows = currValue?.map((r: GridValidRowModel) => r.id === params.id ? { ...r, ...res.payload } : r)
        //                         onChange?.(e, updatedRows)
        //                     }
        //                 }}
        //             >
        //                 {params?.row?.Approval || 0}
        //             </Link>
        //         }
        //     }
        // },
        {
            type: 'number',
            field: 'Amount',
            headerName: "Amount (\u20B9)",
            headerAlign: 'left',
            align: 'right',
            minWidth: 140,
            editable: false,
            filterable: false,
            renderCell: function (params) {
                if (params.id === GRID_AGGREGATION_ROOT_FOOTER_ROW_ID) {
                    return Number(params.value).toFixed(2);
                }
                // only UAT v2.5
                // const handleOnSubmit = async (ratioData: any) => {
                //     let totalPercent = 0
                //     ratioData?.map((item: any) => {
                //         totalPercent += Number(item?.PercentageValue)
                //     })
                //     if (totalPercent === 100) {
                //         let partsData = crud[JobCardKeys?.Parts]?.data
                //         const newRows: any = partsData?.map((r: ResponseObject) => params?.id === r.id ? { ...r, RatioBilling: ratioData } : r);
                //         dispatch(setReducerState({ key: JobCardKeys?.Parts, value: { data: newRows } }))
                //         await saveRatioBillingDetails(ratioData, params.row)
                //         setModalProps(undefined)
                //     } else {
                //         dispatch(
                //             showNotification({
                //                 isOpen: true,
                //                 message: `Ratio contribution must not exceed/less than 100%.`,
                //                 type: "error",
                //             })
                //         );
                //     }
                // }
                // const handleClickRatioBilling = () => {
                //     const modalProps: ResponseObject = {
                //         onSubmit: handleOnSubmit,
                //         rowData: params.row,
                //     };
                //     setModalProps(modalProps);
                // };
                return /*#__PURE__*/ React.createElement(MuiStack, {
                    direction: 'column',
                    justifyContent: 'end'
                }, /*#__PURE__*/ React.createElement(Typography, {
                    fontSize: '12px'
                }, convertNumberToDecimal(params === null || params === void 0 ? void 0 : params.value)));
            }
        }
        // only UAT v2.5
        // {
        //     field: 'Source',
        //     headerName: 'Source',
        //     width: 100,
        //     headerAlign: 'left',
        //     disableColumnMenu: true,
        // },
        // {
        //     field: 'MoreDetails',
        //     headerName: 'More details',
        //     width: 140,
        //     disableColumnMenu: true,
        //     align: 'left',
        //     renderCell: (params) => {
        //         if (params?.id === RowModeIds.Aggregation) {
        //             return '';
        //         } else {
        //             return <Link
        //                 underline="none"
        //                 component="button"
        //                 fontSize='sm'
        //                 fontWeight='medium'
        //                 onClick={async (e) => {
        //                     const res = await dispatch(showSurface({
        //                         type: 'Dialog',
        //                         Component: PartMoreDetails,
        //                         containerProps: { fullWidth: true, maxWidth: 'sm' },
        //                         componentProps: {
        //                             data: params?.row,
        //                         }
        //                     }));
        //                     if (res?.payload) {
        //                         const updatedRows = currValue?.map((r: GridValidRowModel) => r?.id === params?.id ? { ...r, ...res?.payload } : r)
        //                         onChange?.(e, updatedRows)
        //                     }
        //                 }}
        //             >
        //                 View
        //             </Link>
        //         }
        //     }
        // },
    ];
    var handleRowUpdate = function (newRow, oldRow, params) { return __awaiter(void 0, void 0, void 0, function () {
        var newPrices, _newPrices$, _newPrices$2, _newPrices$3, _newPrices$4, _newPrices$5, _newPrices$6, IGST, CGST, SGST, _newRow$SavedPriceWit, _newRow$IssuedQuantit, _newRow$CancelQuantit, _newPrice$payload, _newRow$SavedPriceWit2, newPrice, issuedQty, cancelQty, qty, pendingQty, _newPrice$payload2, _updatedPrice$Taxes, _updatedPrice$Taxes2, _updatedPrice$Taxes3, updatedPrice, IGST, CGST, SGST, _newPrice$payload3, DecimalPrecision, validationRules, _newRow$IssuedQuantit2, _newRow$CancelQuantit2, _newPrice$payload4, newPrice, issuedQty, cancelQty, qty, pendingQty, _newPrice$payload5, _updatedPrice$Taxes4, _updatedPrice$Taxes5, _updatedPrice$Taxes6, updatedPrice, IGST, CGST, SGST, _newPrice$payload6, value_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(oldRow.ServiceTypeId !== newRow.ServiceTypeId || oldRow.UnitOfMeasurementId !== newRow.UnitOfMeasurementId)) return [3 /*break*/, 2];
                    return [4 /*yield*/, getPriceDetailsWithTax(_objectSpread(_objectSpread({}, newRow), {}, {
                            SystemName: "Parts"
                        }), documentDetailsGetById)];
                case 1:
                    newPrices = _a.sent();
                    if (newPrices) {
                        if (newPrices && newPrices.length > 0) {
                            IGST = (_newPrices$ = newPrices[0]) === null || _newPrices$ === void 0 || (_newPrices$ = _newPrices$.Taxes) === null || _newPrices$ === void 0 ? void 0 : _newPrices$.find(function (item) { return item.TaxComponentName === "IGST"; });
                            CGST = (_newPrices$2 = newPrices[0]) === null || _newPrices$2 === void 0 || (_newPrices$2 = _newPrices$2.Taxes) === null || _newPrices$2 === void 0 ? void 0 : _newPrices$2.find(function (item) { return item.TaxComponentName === "CGST"; });
                            SGST = (_newPrices$3 = newPrices[0]) === null || _newPrices$3 === void 0 || (_newPrices$3 = _newPrices$3.Taxes) === null || _newPrices$3 === void 0 ? void 0 : _newPrices$3.find(function (item) { return item.TaxComponentName === "SGST"; });
                            return [2 /*return*/, _objectSpread(_objectSpread({}, newRow), {}, {
                                    PriceWithTaxList: newPrices,
                                    SavedPriceWithTax: newPrices === null || newPrices === void 0 ? void 0 : newPrices[0],
                                    MRP: newPrices[0].MRP,
                                    TaxableAmount: (_newPrices$4 = newPrices[0]) === null || _newPrices$4 === void 0 ? void 0 : _newPrices$4.TaxableAmount,
                                    Amount: (_newPrices$5 = newPrices[0]) === null || _newPrices$5 === void 0 ? void 0 : _newPrices$5.Amount,
                                    Rate: (_newPrices$6 = newPrices[0]) === null || _newPrices$6 === void 0 ? void 0 : _newPrices$6.Rate,
                                    SGST_UTGST_Amount: SGST ? SGST === null || SGST === void 0 ? void 0 : SGST.TaxComponentAmount : 0,
                                    SGST_UTGST_Percentage: SGST ? SGST === null || SGST === void 0 ? void 0 : SGST.TaxComponentPercentage : 0,
                                    CGSTAmount: CGST ? CGST.TaxComponentAmount : 0,
                                    CGSTPercentage: CGST ? CGST.TaxComponentPercentage : 0,
                                    IGSTAmount: IGST ? IGST === null || IGST === void 0 ? void 0 : IGST.TaxComponentAmount : 0,
                                    IGSTPercentage: IGST ? IGST.TaxComponentPercentage : 0,
                                    PriceGroupCategoryKey: newPrices[0].PriceGroupCategoryKey || newRow.PriceGroupCategoryKey
                                })];
                        }
                        else {
                            return [2 /*return*/, newRow];
                        }
                    }
                    else {
                        return [2 /*return*/, newRow];
                    }
                    return [3 /*break*/, 10];
                case 2:
                    if (!(oldRow.Rate !== newRow.Rate)) return [3 /*break*/, 4];
                    if (newRow.Rate < 10) {
                        return [2 /*return*/, _objectSpread(_objectSpread({}, newRow), {}, {
                                error: _objectSpread(_objectSpread({}, newRow.error), {}, {
                                    field: 'Rate',
                                    message: "Rate should be minimum ".concat(10)
                                })
                            })];
                    }
                    if (newRow.Rate > (newRow === null || newRow === void 0 || (_newRow$SavedPriceWit = newRow.SavedPriceWithTax) === null || _newRow$SavedPriceWit === void 0 ? void 0 : _newRow$SavedPriceWit.MaxPrice)) {
                        return [2 /*return*/, _objectSpread(_objectSpread({}, newRow), {}, {
                                error: _objectSpread(_objectSpread({}, newRow.error), {}, {
                                    field: 'Rate',
                                    message: "Rate should not greater than ".concat(newRow === null || newRow === void 0 || (_newRow$SavedPriceWit2 = newRow.SavedPriceWithTax) === null || _newRow$SavedPriceWit2 === void 0 ? void 0 : _newRow$SavedPriceWit2.MaxPrice)
                                })
                            })];
                    }
                    return [4 /*yield*/, validateQuantityAndGetTax(newRow, documentDetailsGetById, installbaseDetailsById)];
                case 3:
                    newPrice = _a.sent();
                    issuedQty = (_newRow$IssuedQuantit = newRow === null || newRow === void 0 ? void 0 : newRow.IssuedQuantity) !== null && _newRow$IssuedQuantit !== void 0 ? _newRow$IssuedQuantit : 0;
                    cancelQty = (_newRow$CancelQuantit = newRow === null || newRow === void 0 ? void 0 : newRow.CancelQuantity) !== null && _newRow$CancelQuantit !== void 0 ? _newRow$CancelQuantit : 0;
                    qty = value - issuedQty;
                    pendingQty = qty - cancelQty;
                    if (newPrice !== null && newPrice !== void 0 && (_newPrice$payload = newPrice.payload) !== null && _newPrice$payload !== void 0 && (_newPrice$payload = _newPrice$payload.value) !== null && _newPrice$payload !== void 0 && _newPrice$payload.data) {
                        updatedPrice = newPrice === null || newPrice === void 0 || (_newPrice$payload2 = newPrice.payload) === null || _newPrice$payload2 === void 0 || (_newPrice$payload2 = _newPrice$payload2.value) === null || _newPrice$payload2 === void 0 ? void 0 : _newPrice$payload2.data;
                        IGST = updatedPrice === null || updatedPrice === void 0 || (_updatedPrice$Taxes = updatedPrice.Taxes) === null || _updatedPrice$Taxes === void 0 ? void 0 : _updatedPrice$Taxes.find(function (item) { return item.TaxComponentName === "IGST"; });
                        CGST = updatedPrice === null || updatedPrice === void 0 || (_updatedPrice$Taxes2 = updatedPrice.Taxes) === null || _updatedPrice$Taxes2 === void 0 ? void 0 : _updatedPrice$Taxes2.find(function (item) { return item.TaxComponentName === "CGST"; });
                        SGST = updatedPrice === null || updatedPrice === void 0 || (_updatedPrice$Taxes3 = updatedPrice.Taxes) === null || _updatedPrice$Taxes3 === void 0 ? void 0 : _updatedPrice$Taxes3.find(function (item) { return item.TaxComponentName === "SGST"; });
                        return [2 /*return*/, _objectSpread(_objectSpread({}, newRow), {}, {
                                // PriceWithTaxList: [updatedPrice],
                                IsPriceUpdate: true,
                                SavedPriceWithTax: _objectSpread(_objectSpread({}, newRow === null || newRow === void 0 ? void 0 : newRow.SavedPriceWithTax), {}, {
                                    "Taxes": updatedPrice.Taxes,
                                    "Rate": updatedPrice.Rate,
                                    "Quantity": updatedPrice.Quantity,
                                    "Amount": updatedPrice.Amount,
                                    "TaxableAmount": updatedPrice.TaxableAmount,
                                    "BaseAmount": updatedPrice.BaseAmount
                                }),
                                MRP: updatedPrice === null || updatedPrice === void 0 ? void 0 : updatedPrice.MRP,
                                TaxableAmount: updatedPrice === null || updatedPrice === void 0 ? void 0 : updatedPrice.TaxableAmount,
                                Amount: updatedPrice === null || updatedPrice === void 0 ? void 0 : updatedPrice.Amount,
                                Rate: updatedPrice === null || updatedPrice === void 0 ? void 0 : updatedPrice.Rate,
                                SGST_UTGST_Amount: SGST ? SGST === null || SGST === void 0 ? void 0 : SGST.TaxComponentAmount : 0,
                                SGST_UTGST_Percentage: SGST ? SGST === null || SGST === void 0 ? void 0 : SGST.TaxComponentPercentage : 0,
                                CGSTAmount: CGST ? CGST.TaxComponentAmount : 0,
                                CGSTPercentage: CGST ? CGST.TaxComponentPercentage : 0,
                                IGSTAmount: IGST ? IGST === null || IGST === void 0 ? void 0 : IGST.TaxComponentAmount : 0,
                                IGSTPercentage: IGST ? IGST.TaxComponentPercentage : 0,
                                PriceGroupCategoryKey: updatedPrice.PriceGroupCategoryKey || newRow.PriceGroupCategoryKey,
                                PendingQuantity: pendingQty >= 0 ? pendingQty : 0,
                                error: undefined
                            })];
                    }
                    else {
                        return [2 /*return*/, _objectSpread(_objectSpread({}, newRow), {}, {
                                error: _objectSpread(_objectSpread({}, newRow.error), {}, {
                                    field: 'Rate',
                                    message: newPrice === null || newPrice === void 0 || (_newPrice$payload3 = newPrice.payload) === null || _newPrice$payload3 === void 0 || (_newPrice$payload3 = _newPrice$payload3.value) === null || _newPrice$payload3 === void 0 ? void 0 : _newPrice$payload3.message
                                })
                            })];
                    }
                    return [3 /*break*/, 10];
                case 4:
                    if (!(oldRow.Quantity !== newRow.Quantity)) return [3 /*break*/, 9];
                    if (!newRow.Quantity) {
                        return [2 /*return*/, _objectSpread(_objectSpread({}, newRow), {}, {
                                error: _objectSpread(_objectSpread({}, newRow.error), {}, {
                                    field: 'Quantity',
                                    message: "This field is required"
                                })
                            })];
                    }
                    if (!!(+newRow.Quantity > 0)) return [3 /*break*/, 5];
                    return [2 /*return*/, _objectSpread(_objectSpread({}, newRow), {}, {
                            error: _objectSpread(_objectSpread({}, newRow.error), {}, {
                                field: 'Quantity',
                                message: "Quantity should be greater than 0"
                            })
                        })];
                case 5:
                    DecimalPrecision = newRow.DecimalPrecision;
                    validationRules = {
                        0: REG.validateInteger,
                        1: REG.validateDecimalUptoOneDigit,
                        2: REG.validateDecimalAndNonNumeric
                    };
                    if (!(DecimalPrecision !== undefined && validationRules[DecimalPrecision])) return [3 /*break*/, 8];
                    if (!!validationRules[DecimalPrecision].test(newRow.Quantity)) return [3 /*break*/, 6];
                    return [2 /*return*/, _objectSpread(_objectSpread({}, newRow), {}, {
                            error: _objectSpread(_objectSpread({}, newRow.error), {}, {
                                field: 'Quantity',
                                message: DecimalPrecision === 0 ? "Enter Qty in multiple of 1" : "Up to ".concat(DecimalPrecision, " decimal precision is allowed")
                            })
                        })];
                case 6: return [4 /*yield*/, validateQuantityAndGetTax(newRow, documentDetailsGetById, installbaseDetailsById)];
                case 7:
                    newPrice = _a.sent();
                    issuedQty = (_newRow$IssuedQuantit2 = newRow === null || newRow === void 0 ? void 0 : newRow.IssuedQuantity) !== null && _newRow$IssuedQuantit2 !== void 0 ? _newRow$IssuedQuantit2 : 0;
                    cancelQty = (_newRow$CancelQuantit2 = newRow === null || newRow === void 0 ? void 0 : newRow.CancelQuantity) !== null && _newRow$CancelQuantit2 !== void 0 ? _newRow$CancelQuantit2 : 0;
                    qty = (newRow === null || newRow === void 0 ? void 0 : newRow.Quantity) - issuedQty;
                    pendingQty = qty - cancelQty;
                    if (newPrice !== null && newPrice !== void 0 && (_newPrice$payload4 = newPrice.payload) !== null && _newPrice$payload4 !== void 0 && (_newPrice$payload4 = _newPrice$payload4.value) !== null && _newPrice$payload4 !== void 0 && _newPrice$payload4.data) {
                        updatedPrice = newPrice === null || newPrice === void 0 || (_newPrice$payload5 = newPrice.payload) === null || _newPrice$payload5 === void 0 || (_newPrice$payload5 = _newPrice$payload5.value) === null || _newPrice$payload5 === void 0 ? void 0 : _newPrice$payload5.data;
                        IGST = updatedPrice === null || updatedPrice === void 0 || (_updatedPrice$Taxes4 = updatedPrice.Taxes) === null || _updatedPrice$Taxes4 === void 0 ? void 0 : _updatedPrice$Taxes4.find(function (item) { return item.TaxComponentName === "IGST"; });
                        CGST = updatedPrice === null || updatedPrice === void 0 || (_updatedPrice$Taxes5 = updatedPrice.Taxes) === null || _updatedPrice$Taxes5 === void 0 ? void 0 : _updatedPrice$Taxes5.find(function (item) { return item.TaxComponentName === "CGST"; });
                        SGST = updatedPrice === null || updatedPrice === void 0 || (_updatedPrice$Taxes6 = updatedPrice.Taxes) === null || _updatedPrice$Taxes6 === void 0 ? void 0 : _updatedPrice$Taxes6.find(function (item) { return item.TaxComponentName === "SGST"; });
                        return [2 /*return*/, _objectSpread(_objectSpread({}, newRow), {}, {
                                // PriceWithTaxList: [updatedPrice],
                                SavedPriceWithTax: _objectSpread(_objectSpread({}, newRow.SavedPriceWithTax), {}, {
                                    "Taxes": updatedPrice.Taxes,
                                    "Rate": updatedPrice.Rate,
                                    "Quantity": updatedPrice.Quantity,
                                    "Amount": updatedPrice.Amount,
                                    "TaxableAmount": updatedPrice.TaxableAmount,
                                    "BaseAmount": updatedPrice.BaseAmount
                                }),
                                MRP: updatedPrice === null || updatedPrice === void 0 ? void 0 : updatedPrice.MRP,
                                TaxableAmount: updatedPrice === null || updatedPrice === void 0 ? void 0 : updatedPrice.TaxableAmount,
                                Amount: updatedPrice === null || updatedPrice === void 0 ? void 0 : updatedPrice.Amount,
                                Rate: updatedPrice === null || updatedPrice === void 0 ? void 0 : updatedPrice.Rate,
                                SGST_UTGST_Amount: SGST ? SGST === null || SGST === void 0 ? void 0 : SGST.TaxComponentAmount : 0,
                                SGST_UTGST_Percentage: SGST ? SGST === null || SGST === void 0 ? void 0 : SGST.TaxComponentPercentage : 0,
                                CGSTAmount: CGST ? CGST.TaxComponentAmount : 0,
                                CGSTPercentage: CGST ? CGST.TaxComponentPercentage : 0,
                                IGSTAmount: IGST ? IGST === null || IGST === void 0 ? void 0 : IGST.TaxComponentAmount : 0,
                                IGSTPercentage: IGST ? IGST.TaxComponentPercentage : 0,
                                PriceGroupCategoryKey: updatedPrice.PriceGroupCategoryKey || newRow.PriceGroupCategoryKey,
                                PendingQuantity: pendingQty >= 0 ? pendingQty : 0,
                                error: undefined
                            })];
                    }
                    else {
                        return [2 /*return*/, _objectSpread(_objectSpread({}, newRow), {}, {
                                error: _objectSpread(_objectSpread({}, newRow.error), {}, {
                                    field: 'Quantity',
                                    message: newPrice === null || newPrice === void 0 || (_newPrice$payload6 = newPrice.payload) === null || _newPrice$payload6 === void 0 || (_newPrice$payload6 = _newPrice$payload6.value) === null || _newPrice$payload6 === void 0 ? void 0 : _newPrice$payload6.message
                                })
                            })];
                    }
                    _a.label = 8;
                case 8: return [3 /*break*/, 10];
                case 9:
                    if (oldRow.SavedPriceWithTax !== newRow.SavedPriceWithTax) {
                        value_1 = newRow.SavedPriceWithTax;
                        // let IGST = value?.Taxes?.find((item: any) => item.TaxComponentName === "IGST")
                        // let CGST = value?.Taxes?.find((item: any) => item.TaxComponentName === "CGST")
                        // let SGST = value?.Taxes?.find((item: any) => item.TaxComponentName === "SGST")
                        return [2 /*return*/, _objectSpread(_objectSpread({}, newRow), {}, {
                                SavedPriceWithTax: value_1,
                                MRP: value_1 === null || value_1 === void 0 ? void 0 : value_1.MRP,
                                TaxableAmount: value_1 === null || value_1 === void 0 ? void 0 : value_1.TaxableAmount,
                                Amount: value_1 === null || value_1 === void 0 ? void 0 : value_1.Amount,
                                Rate: value_1 === null || value_1 === void 0 ? void 0 : value_1.Rate
                                // SGST_UTGST_Amount: SGST ? SGST?.TaxComponentAmount : 0,
                                // SGST_UTGST_Percentage: SGST ? SGST?.TaxComponentPercentage : 0,
                                // CGSTAmount: CGST ? CGST.TaxComponentAmount : 0,
                                // CGSTPercentage: CGST ? CGST.TaxComponentPercentage : 0,
                                // IGSTAmount: IGST ? IGST?.TaxComponentAmount : 0,
                                // IGSTPercentage: IGST ? IGST.TaxComponentPercentage : 0,
                            })];
                    }
                    _a.label = 10;
                case 10: return [2 /*return*/, newRow];
            }
        });
    }); };
    return /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12
    }, /*#__PURE__*/ React.createElement(EditableDataGrid, {
        dataGridHeader: "Part",
        isCollapsible: true,
        columns: partsColumns,
        disableDeleteRow: disabled,
        disableAddRow: disabled,
        dataGridProps: {
            processRowUpdate: handleRowUpdate,
            checkboxSelection: !disabled,
            disableRowSelectionOnClick: true,
            disableRowGrouping: true,
            hideFooter: true,
            initialState: {
                pinnedColumns: {
                    left: [GRID_CHECKBOX_SELECTION_FIELD, GRID_ROW_GROUPING_SINGLE_GROUPING_FIELD, 'ChildName'],
                    right: ['MoreDetails']
                },
                aggregation: {
                    model: {
                        Amount: 'sum',
                        TotalTaxes: 'sum',
                        TaxableAmount: 'sum',
                        TradeDiscountAmount: 'sum',
                        CancelQuantity: 'sum',
                        ReturnedQuantity: 'sum',
                        NotIssuedQuantity: 'sum',
                        PendingQuantity: 'sum',
                        // AvailableQuantity: 'sum',
                        IssuedQuantity: 'sum',
                        Quantity: 'sum'
                    }
                }
            },
            isCellEditable: function (params) {
                var _params$row6;
                if (disabled)
                    return false;
                if ((params === null || params === void 0 ? void 0 : params.field) === "Rate") {
                    // return (params?.row?.IsAutoFill === false) || 
                    // params?.row?.SavedPriceWithTax?.IsRateEditable ||
                    return false;
                }
                return (params === null || params === void 0 ? void 0 : params.field) === 'ChildName' || Boolean(params === null || params === void 0 || (_params$row6 = params.row) === null || _params$row6 === void 0 ? void 0 : _params$row6.ChildName);
            },
            // getRowHeight(params) {
            //     return params.id === RowModeIds.Aggregation ? 44 : 68
            // },
            onCellEditStart: function () {
                dispatch(setReducerState({
                    key: JobCardKeys.DisableSubmit,
                    value: true
                }));
            },
            onCellEditStop: function () {
                dispatch(setReducerState({
                    key: JobCardKeys.DisableSubmit,
                    value: false
                }));
            },
            onCellClick: function (_ref4, e, _ref5) {
                var id = _ref4.id, field = _ref4.field, isEditable = _ref4.isEditable, cellMode = _ref4.cellMode;
                var api = _ref5.api;
                if (isEditable && cellMode === 'view') {
                    api === null || api === void 0 || api.startCellEditMode({
                        id: id,
                        field: field
                    });
                    dispatch(setReducerState({
                        key: JobCardKeys.DisableSubmit,
                        value: true
                    }));
                }
            },
            getCellClassName: function (params) {
                return !params.isEditable ? "".concat(gridClasses.cell, "--disabled") : "";
            },
            sx: (_a = {},
                _a[".".concat(gridClasses.cell, "--disabled")] = {
                    bgcolor: 'secondary.50'
                },
                _a[".".concat(gridClasses["cell--editable"])] = {
                    cursor: 'pointer'
                },
                _a)
        },
        rows: currValue || [],
        onChange: onChange,
        error: error === null || error === void 0 ? void 0 : error[name],
        visibleActions: {
            add: false,
            upload: false
        },
        onToolbarButtonClick: function (e, params) { return __awaiter(void 0, void 0, void 0, function () {
            var _params$api, selectedRows_1, updatedAllList, req, validateResponse;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(e.currentTarget.id === 'delete')) return [3 /*break*/, 2];
                        selectedRows_1 = params === null || params === void 0 || (_params$api = params.api) === null || _params$api === void 0 || (_params$api = _params$api.current) === null || _params$api === void 0 ? void 0 : _params$api.getSelectedRows();
                        updatedAllList = currValue === null || currValue === void 0 ? void 0 : currValue.map(function (item) {
                            var isSelected = selectedRows_1 === null || selectedRows_1 === void 0 ? void 0 : selectedRows_1.has(item.id);
                            if (isSelected) {
                                return _objectSpread(_objectSpread({}, item), {}, {
                                    "UserDeleted": true,
                                    "IsActive": false,
                                    "IsDeleted": true
                                });
                            }
                            else {
                                return _objectSpread(_objectSpread({}, item), {}, {
                                    "UserDeleted": false
                                });
                            }
                        });
                        req = {
                            "SystemName": "Products",
                            "Products": updatedAllList
                        };
                        return [4 /*yield*/, validateDeletePartLabour({
                                request: req
                            })];
                    case 1:
                        validateResponse = _a.sent();
                        if (validateResponse.success && validateResponse.statusCode === 200) {
                            onChange === null || onChange === void 0 || onChange(e, updatedAllList);
                        }
                        return [2 /*return*/, false];
                    case 2: return [2 /*return*/, true];
                }
            });
        }); },
        validationModel: {
            Quantity: function (currValue, row) {
                if (currValue === 0) {
                    return "You cannot set requested quantity as zero.";
                }
                if (!currValue) {
                    return "This field is required";
                }
                if (currValue < 0) {
                    return "You cannot set requested quantity less than zero.";
                }
                if (Number(currValue) > 999999.99) {
                    return "Quantity cannot be greater than 999999.99";
                }
                var DecimalPrecision = row.DecimalPrecision;
                var validationRules = {
                    0: REG.validateInteger,
                    1: REG.validateDecimalUptoOneDigit,
                    2: REG.validateDecimalAndNonNumeric
                };
                if (DecimalPrecision !== undefined && validationRules[DecimalPrecision]) {
                    if (!validationRules[DecimalPrecision].test(currValue)) {
                        return DecimalPrecision === 0 ? "Enter Qty in multiple of 1" : "Up to ".concat(DecimalPrecision, " decimal precision is allowed");
                    }
                    return "";
                }
            }
        }
    }));
};
export default JobcardPartGrid;
